import { render, staticRenderFns } from "./HeadlineWrap.vue?vue&type=template&id=68ea7158&scoped=true"
import script from "./HeadlineWrap.vue?vue&type=script&lang=js"
export * from "./HeadlineWrap.vue?vue&type=script&lang=js"
import style0 from "./HeadlineWrap.vue?vue&type=style&index=0&id=68ea7158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea7158",
  null
  
)

export default component.exports